import { Component, OnInit, Input } from '@angular/core';

import { Deslocamento } from "../shared/deslocamento.model";
import { deslocamentosModuleName } from "../shared/data.service";
import { DeslocamentoApiService } from "../shared/deslocamento-api.service";
import { DeslocamentoNavigationService } from "../shared/deslocamento-navigation.service";
import { UtilService } from "../../../shared/services/util.service";

@Component({
    selector: 'app-deslocamento-table',
    template: require('./deslocamento-table.component.html'),
    styles: [require('./deslocamento-table.component.css')]
})
export class DeslocamentoTableComponent implements OnInit {
    @Input() list: Deslocamento[] = [];
    @Input() showDisabled: boolean = false;
    @Input() loading: boolean = true;
    @Input() researched: boolean = true;

    deslocamentosModuleName: any = deslocamentosModuleName;

    constructor(
        private _deslocamentosApiService: DeslocamentoApiService,
        private _deslocamentoNavigationService: DeslocamentoNavigationService,
        private _utilService: UtilService
    ) { }

    ngOnInit() {

    }

    clickDetail(item: Deslocamento) {
        this._deslocamentoNavigationService.goToDetail(item.id);
    }

    clickDelete(item: Deslocamento) {
        let onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    private onDelete(item: any) {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._deslocamentosApiService.onDelete(item.id, onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamentos/deslocamento-table/deslocamento-table.component.ts
 **/